import { Component } from '@angular/core';

import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
	selector: 'formly-field-textarea',
	template: `
		<vp-textarea
			[autocomplete]="props['autocomplete']"
			[formControl]="formControl"
			[hasError]="showError"
			[initialValue]="formControl.value"
			[isOptional]="props['optional']"
			[isValid]="formControl.valid"
			[name]="field.id"
			[placeholder]="props.placeholder"
			[readonly]="props.readonly"
			[rows]="props['rows']"
			[textareaId]="field.id"
			ngDefaultControl
		/>
	`,
	standalone: false,
})
export class TextareaComponent extends FieldType<FieldTypeConfig> {}
